import React, { Component } from 'react';


class Completion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rateJg:[],
      maxrate:18,
      data:[],
      ck_list:[[],[],[],[],[],[],[],[],[],[]]
  }
}
 rate=(id,pro,index,e)=>{
  let rateJg1=this.state.rateJg;
  let rateVal=(e.target.value)/1;
//  let rateVal=e.target.value.replace(/[^\d]/g,"");
 if(rateVal>(pro/1)){
  rateJg1[index]=true;
  this.setState({
    rateJg:rateJg1
  })

 }else{
  rateJg1[index]=false;
  this.setState({
    rateJg:rateJg1
  })
  

 }
  
}
return_answer=(answerList)=>{
  var str="";
  //console.log(answerList);
  for(let i=0;i<answerList.length;i++){
    str+=answerList[i].answerName
  }
  return str;
}

ratea=(id,questionGrade,answerList,index,indexa,questionType,e)=>{
  let ck_list=this.state.ck_list;
  ck_list[index][indexa]=e.target.value;
  this.setState({
    ck_list:ck_list
  })
  //if(ck_list[index].toString())
  //console.log(this.return_answer(answerList));
  //console.log(ck_list[index].join(""));
  if(this.return_answer(answerList)===ck_list[index].join("")){
    let ck = ck_list[index].join("")?ck_list[index].join(" ；"):ck_list[index].join("")
    this.props.subCard(id,ck,1,questionGrade,questionType);
  }else{   
    let ck = ck_list[index].join("")?ck_list[index].join(" ；"):ck_list[index].join("")
    this.props.subCard(id,ck,0,0,questionType);
  }
  
 

 
  
}

componentDidMount(){
  this.setState({
    data: this.props.data
  }) 
}

imgShow=(e)=>{

  this.props.imgShow(e);
}
componentDidUpdate(){
  
}
// value=value
  render() {
    if(this.state.data&&this.state.data.length>0){
    return (
      <div>
        
          {
          this.state.data.map((val,index)=>{
                return(
                  <div key={index}>
                  <div className="single_title" onClick={this.imgShow}>
                  {this.props.Skey}.({this.props.listXX}题) <span dangerouslySetInnerHTML = {{ __html:val.question }}></span>({val.questionGrade}分)                  </div>
                {
                  val.cardList&&val.cardList.length>0?<div></div>:
                  val.answerList.map((vala,indexa)=>{
                return(
                  
                  <p className="rate_con" key={indexa}>
                  <input type="text" maxLength="30" className={this.state.rateJg[index]===true?"user_rate rate_err":"user_rate"}  disabled={val.cardList&&val.cardList.length>0}   placeholder={`请输入填空题答案`} ref="user_rate" 
                   onBlur={this.ratea.bind(this,val.id,val.questionGrade,val.answerList,index,indexa,val.questionType)}  />
                </p>
                  )
                  })
                }
                
                 {
                  this.props.ansShow===true&&this.props.isDid===true?
                  <div className="ans_con" onClick={this.imgShow}>
                    {
                      val.cardList&&val.cardList.length>0?
                      <div className="ans_title">您的答案是 <span className="ans_right ans_blk ans_self">{val.answerList.cardList<0?"未填写":val.cardList[0].optChoose}</span></div>
                      :<div></div>
                  }
                   <div className="ans_title">正确答案是 <span className="ans_right ans_blk">{val.answerList.length<0?"见解析":<span dangerouslySetInnerHTML = {{ __html:val.optionTrue }}></span>}</span></div>
                   <div className='ans_tip'>解析</div>
                   <div className="ans_jx"><span dangerouslySetInnerHTML = {{ __html:val.analysis}}></span></div>
                  </div>
                 :
                 <div className="ans_cli"></div>
              }
                  
           </div>
                 )
          })
        }
      
      </div>
    );
 
}else{
  return(<div></div>)
}
}
}

export default Completion;
